import { NgModule } from '@angular/core';

import {
  DeleteZeitCommandComponentModule, DeleteZeitCommandServiceModule
} from '.';

@NgModule({
  imports: [
    DeleteZeitCommandServiceModule,
    DeleteZeitCommandComponentModule
  ],
  exports: [
    DeleteZeitCommandServiceModule,
    DeleteZeitCommandComponentModule
  ]
})
export class DeleteZeitCommandModule { }
